import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
} from "redux";

import { thunk } from "redux-thunk";
import {
  userLoginReducer,
  userRefreshTokenReducer,
} from "../Reducer/loginReducer";
import { getBranchReducer } from "../Reducer/BranchReducer/BranchReducer";
import {
  getPatientReducer,
  getPatientReportReducer,
  showPatientReducer,
} from "../Reducer/PatientReducer/PatientReducer";
import { getFormReducer } from "../Reducer/FormReducer/FormReducer";
import { getVisitReducer } from "../Reducer/VisitReducder/VisitReducer";
import {
  createFieldReducer,
  getFieldsReducer,
  getSectionFormsReducer,
  showFieldsReducer,
} from "../Reducer/Section&FieldsReducer/SectionFormReducer";
import {
  createDoctoReducer,
  getDoctoReducer,
} from "../Reducer/DoctorReducer/DoctorReducer";
import {
  createOrganReducer,
  createSurgeryReducer,
  createTypeSurgeryReducer,
  getOrganReducer,
  getSurgeryByIdsReducer,
  getSurgeryReducer,
  getTypeSurgeryReducer,
  showOrganReducer,
  showTypeSurgeryReducer,
  updateOrganReducer,
  updateSurgeryReducer,
  updateTypeSurgeryReducer,
} from "../Reducer/SurgeryReducer/SurgeryReducer";
import {
  createAffiarsOfSurgeryReducer,
  updateAffiarsOfSurgeryReducer,
} from "../Reducer/AffiarsOfSurgeryReducer/AffiarsOfSurgeryReducer";
import {
  createTypeOfHelpReducer,
  getTypeOfHelpReducer,
  updateTypeOfHelpReducer,
} from "../Reducer/SurgeryReducer/TypeOfHelpReducer";
import { getComeBackDoctorReducer } from "../Reducer/ComeBackDoctorReducer/ComeBackDoctorReducer";
import {
  createWhatsAppReducer,
  getWhatsAppReducer,
} from "../Reducer/WhatsAppReducer/WhatsAppReducer";
import {
  createTypeFieldReducer,
  getTypeFieldByListNameReducer,
  getTypeFieldReducer,
  getTypeFieldValueReducer,
  showTypeFieldReducer,
  updateTypeFieldReducer,
} from "../Reducer/TypeFieldReducer/TypeFieldReducer";
import {
  createMedicalSupliesReducer,
  getMedicalSupliesReducer,
  updateMedicalSupliesReducer,
} from "../Reducer/MedicalSupliesReducer/MedicalSupliesReducer";
import { getRejectReducer } from "../Reducer/RejectReducer/RejectReducer";
import {
  createUnderGoneSurgeryReducer,
  getUndergoneSurgeryReducer,
  updateUndergoneSurgeryReducer,
} from "../Reducer/UndergoneSurgeryReducer/UndergoneSurgeryReducer";
import {
  changeUserPasswordReducer,
  createUserReducer,
  getUserAuthReducer,
  getUserCvReducer,
  getUsersReducer,
  profileUserReducer,
  updateUserEmaildReducer,
} from "../Reducer/UserReducer/UserReducer";
import {
  createRoleReducer,
  getRoleReducer,
} from "../Reducer/RoleReudcer/RoleRedcuer";
import { getPositionReducer } from "../Reducer/BranchReducer/PositionReducer";
import { showPageReducer } from "../Reducer/BranchReducer/PageReducer";
import {
  createPermissionReducer,
  showPermissionReducer,
} from "../Reducer/BranchReducer/PermissionReducer";
import { getStatisticsReducer } from "../Reducer/StatisticsReducer/StatisticsReducer";
import {
  createMediaAllInformationReducer,
  createMediaInformationReducer,
} from "../Reducer/MeidaInformationReducer/MediaInformationReducer";
import { excelReducer } from "../Reducer/ExcelReducer/ExcelReducer";
import {
  getSharedDataReducer,
  sendSharedDataReducer,
} from "../Reducer/SharedDataReducer/SharedDataReducer";
import { showAttendanceReducer } from "../Reducer/UserReducer/AttendanceReducer";
import { showDropDwonValuesReducer } from "../Reducer/Section&FieldsReducer/DropdwonReducer";
import { getHospitalReducer } from "../Reducer/HospitalReducer/HospitalReducer";
const rootReducer = combineReducers({
  // users reducers
  getUsers: getUsersReducer,
  createUser: createUserReducer,
  getUserAuth: getUserAuthReducer,
  userLogin: userLoginReducer,
  changeUserPassword: changeUserPasswordReducer,
  updateUserEmail: updateUserEmaildReducer,
  profileUser: profileUserReducer,
  getUserCv: getUserCvReducer,
  //

  getBranch: getBranchReducer,
  getPatient: getPatientReducer,
  showPatient: showPatientReducer,
  getPatientReport: getPatientReportReducer,

  getForm: getFormReducer,
  getVisit: getVisitReducer,
  getSectionForms: getSectionFormsReducer,
  getFields: getFieldsReducer,
  createField: createFieldReducer,
  showFields:showFieldsReducer,

  getDoctor: getDoctoReducer,
  createDoctor: createDoctoReducer,

  getSurgery: getSurgeryReducer,
  updateSurgery: updateSurgeryReducer,
  createSurgery: createSurgeryReducer,

  getTypeSurgery: getTypeSurgeryReducer,
  updateTypeSurgery: updateTypeSurgeryReducer,
  createTypeSurgery: createTypeSurgeryReducer,

  getOrgan: getOrganReducer,
  createOrgan: createOrganReducer,
  updateOrgan: updateOrganReducer,

  showTypeSurgery: showTypeSurgeryReducer,
  showOrgan: showOrganReducer,

  createAffiarsOfSurgery: createAffiarsOfSurgeryReducer,
  updateAffiarsOfSurgery: updateAffiarsOfSurgeryReducer,

  getTypeOfHelp: getTypeOfHelpReducer,
  createTypeOfHelp: createTypeOfHelpReducer,
  updateTypeOfHelp: updateTypeOfHelpReducer,

  getComeBackDoctor: getComeBackDoctorReducer,

  createWhatsApp: createWhatsAppReducer,
  getWhatsApp: getWhatsAppReducer,

  createTypeField: createTypeFieldReducer,
  getTypeField: getTypeFieldReducer,
  showTypeField: showTypeFieldReducer,
  updateTypeField: updateTypeFieldReducer,

  getTypeFieldValue: getTypeFieldValueReducer,
  getTypeFieldByListName: getTypeFieldByListNameReducer,

  getMedicalSuplies: getMedicalSupliesReducer,
  updateMedicalSuplies: updateMedicalSupliesReducer,
  createMedicalSuplies: createMedicalSupliesReducer,

  updateUndergoneSurgery: updateUndergoneSurgeryReducer,
  getUndergoneSurgery: getUndergoneSurgeryReducer,
  createUnderGoneSurgery: createUnderGoneSurgeryReducer,

  getReject: getRejectReducer,
  getRole: getRoleReducer,
  createRole: createRoleReducer,
  getPosition: getPositionReducer,
  showPage: showPageReducer,

  createPermission: createPermissionReducer,
  showPermission: showPermissionReducer,
  getStatistics: getStatisticsReducer,

  userRefreshToken: userRefreshTokenReducer,

  createMediaInformation: createMediaInformationReducer,
  createMediaAllInformation: createMediaAllInformationReducer,
  excelReducer: excelReducer,
  showAttendance: showAttendanceReducer,

  sendSharedData: sendSharedDataReducer,
  getSharedData: getSharedDataReducer,
  showDropDwonValues: showDropDwonValuesReducer,

  getHospital:getHospitalReducer,
  // createHospital:createHospitalReducer,
});

export const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
